/**
 * Extracted from sections/ns-testimonials-slider.liquid (inline <script> at line 235).
 * Moved verbatim into a cacheable, deferred asset so the browser can cache it
 * across page loads and stop parsing/compiling it during the HTML parse.
 * Found while fixing INP on the PDP (inline JS was the largest first-party
 * main-thread cost). Logic intentionally unchanged.
 */

// --- original inline block #1 (was at sections/ns-testimonials-slider.liquid:235) ---
(function () {
  function testimonialSliderInit () {

   let contentContainerEl = document.querySelector('.testimonial-slider')

   let {
      itemsPerRowDesktop,
    } = contentContainerEl.dataset

    const testSwiper = new Swiper('.testimonial-slider__wrapper', {
      slidesPerView: 1.125,
      spaceBetween: 10,

      speed: 600,

      breakpoints: {
        320: {
          slidesPerView: 1.33,
          spaceBetween: 10
        },
        480: {
          slidesPerView: 1.625,
          spaceBetween: 15
        },
        640: {
          slidesPerView: 2,
          spaceBetween: 15
        },
        800: {
          slidesPerView: 3,
          spaceBetween: 15
        },
        1024: {
          slidesPerView: itemsPerRowDesktop ? itemsPerRowDesktop : 4,
          spaceBetween: 30
        }
      },

      autoHeight: true,

      navigation: {
        nextEl: '.testimonial-slider__swiper-button-next',
        prevEl: '.testimonial-slider__swiper-button-prev',
      },

      pagination: {
        el: ".testimonial-slider__swiper-pagination",
        clickable: true
      },

    })
  }

  // ns-swiper-min.js is deferred, so guard on the Swiper global rather than
  // relying on script order. nsSwiperReady is defined inline in <head> by
  // snippets/swiper-ready.liquid.
  nsSwiperReady(testimonialSliderInit)

  if (Shopify.designMode) {
      document.addEventListener("shopify:section:load", () => {
        nsSwiperReady(testimonialSliderInit)
      });
  }
})();
